import { useAppSelector } from '../../app/hooks'
import { selectUserProperty, UserProperties } from './userSlice'

export const useUserProperty = (key: string) => {
  return useAppSelector(selectUserProperty(key as UserProperties))
}
